import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const threadsApi = createApi({
  reducerPath: "threads",
  baseQuery: fetchBaseQuery({
    baseUrl: !window.location.href.includes('test') ? process.env.REACT_APP_API_URL : 'https://apitest.glassen-it.com/component/socparser/',
  }),
  endpoints: ({ query }) => ({
    threads: query({
      query: () => ({
        url: "threads/get",
        credentials: "include",
      }),
    }),
    threadsList: query({
      query: (body) => ({
        url: "threads/getThreadsList",
        method: "post",
        credentials: "include",
        body,
      }),
    }),
    threadsIogvList: query({
      query: (body) => ({
        url: "threads/getThreadsIogvList",
        method: "post",
        credentials: "include",
        body,
      }),
    }),
    threadItem: query({
      query: (body) => ({
        url: "thread/getthreadextended",
        method: "POST",
        credentials: "include",
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useThreadsQuery, useThreadsListQuery, useThreadsIogvListQuery, useThreadItemQuery } = threadsApi;
